import { css, cx } from 'emotion';

import CircleBG from 'inside-out/images/home/circle-bg.svg';
import WhoWeAre from 'inside-out/images/home/who-we-are.svg';

import {
	pink,
	grey,
	darkGrey,
	orange,
	museo900,
	headingLarge,
	textBlock,
	contentSection,
	cardSection,
	mobileMaxWidthBreakpoint,
	mobileMinWidthBreakpoint,
	desktopMaxWidthBreakpoint,
	tabletPortraitMaxWidthBreakpoint,
	tabletPortraitMinWidthBreakpoint,
	tabletLandscapeMinWidthBreakpoint,
	desktopMinWidthBreakpoint,
} from 'inside-out/global-styles';

export const innerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '100%',
	margin: '0 auto',
	padding: '0 20px',
	overflowX: 'hidden',
});

export const heroStyle = css({
	boxSizing: 'border-box',
	position: 'relative',

	[`@media (min-width: ${mobileMinWidthBreakpoint}px)`]: {
		paddingTop: '22px',
		height: '396px',
	},
	[`@media (min-width: ${tabletPortraitMinWidthBreakpoint}px)`]: {
		paddingTop: '62px',
		height: '444px',
	},
});

export const heroBackgroundStyle = bgImage =>
	css({
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		overflow: 'hidden',

		'& > video': {
			minWidth: '100%',
			minHeight: '100%',
			width: 'auto',
			height: 'auto',
			position: 'absolute',
			left: '50%',
			top: '50%',
			transform: 'translate(-50%, -50%)',

			[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
				display: 'none',
			},
		},

		[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
			background: `url(${bgImage}) no-repeat center`,
			backgroundSize: 'cover',
		},
	});

export const heroTitleStyle = css({
	...museo900,
	fontWeight: 'normal',
	margin: 0,
	color: '#fff',
	position: 'relative',
	zIndex: '1',

	[`@media (min-width: ${tabletPortraitMinWidthBreakpoint}px)`]: {
		width: '620px',
	},
});

export const heroBodyStyle = css({
	color: '#fff',
	position: 'relative',
	zIndex: '1',

	[`@media (min-width: ${tabletPortraitMinWidthBreakpoint}px)`]: {
		width: '620px',
	},
});

export const heroBodyCTAStyle = css({
	...museo900,

	color: '#fff',
	margin: '0 0 10px',
	position: 'relative',
	zIndex: '1',

	[`@media (min-width: ${mobileMinWidthBreakpoint}px)`]: {
		fontSize: '16px',
		lineHeight: '19px',
	},
	[`@media (min-width: ${tabletPortraitMinWidthBreakpoint}px)`]: {
		fontSize: '18px',
		lineHeight: '22px',
	},
});

export const cardsStyle = css({
	position: 'relative',
	zIndex: '1',
	marginTop: '-146px',
});

export const titleStyle = cx(
	headingLarge,
	css({
		marginBottom: '24px',
		width: '525px',
		[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
			lineHeight: '47px',
		},
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			fontSize: '20px',
			lineHeight: '23px',
			width: '286px',
		},
	})
);

export const bodyTextStyle = cx(
	textBlock,
	css({
		'& div p:last-child': {
			marginBottom: '39px',
		},
	})
);

export const whatAreEatingDisordersStyle = css({
	position: 'relative',
	margin: '30px 0',
	[`@media (min-width: ${tabletPortraitMinWidthBreakpoint}px)`]: {
		margin: '150px 0',
	},
});

export const disordersLeftStyle = css({
	[`@media (min-width: ${tabletPortraitMinWidthBreakpoint}px)`]: {
		width: '500px',
	},
});

export const disordersRightStyle = css({
	position: 'absolute',
	top: '50%',
	transform: 'translateY(-50%)',
	right: '0',

	[`@media (min-width: ${mobileMinWidthBreakpoint}px)`]: {
		display: 'none',
	},
	[`@media (min-width: ${tabletPortraitMinWidthBreakpoint}px)`]: {
		display: 'block',
		width: '258px',
	},
	[`@media (min-width: ${tabletLandscapeMinWidthBreakpoint}px)`]: {
		width: '384px',
	},
	[`@media (min-width: ${desktopMinWidthBreakpoint}px)`]: {
		width: '529px',
	},

	'& > div': {
		position: 'relative',
		zIndex: '2',
		width: '100%',

		[`@media (min-width: ${tabletPortraitMinWidthBreakpoint}px)`]: {
			display: 'block',
			paddingLeft: '19px',
			width: '212px',
		},

		[`@media (min-width: ${tabletLandscapeMinWidthBreakpoint}px)`]: {
			paddingLeft: '57px',
			width: '287px',
		},

		[`@media (min-width: ${desktopMinWidthBreakpoint}px)`]: {
			paddingLeft: '51px',
			width: '376px',
		},

		'& p:first-child': {
			...museo900,
			color: orange,
			margin: '0',

			[`@media (min-width: ${tabletPortraitMinWidthBreakpoint}px)`]: {
				fontSize: '36px',
				lineHeight: '43px',
			},

			[`@media (min-width: ${tabletLandscapeMinWidthBreakpoint}px)`]: {
				fontSize: '50px',
				lineHeight: '60px',
			},

			[`@media (min-width: ${desktopMinWidthBreakpoint}px)`]: {
				fontSize: '64px',
				lineHeight: '77px',
			},
		},
		'& p:last-child': cx(
			textBlock,
			css({
				color: darkGrey,
				margin: 0,
			})
		),
	},

	'&:after': {
		zIndex: '1',
		position: 'absolute',
		width: '100%',
		height: '1360px',
		content: '" "',
		display: 'block',
		top: '50%',
		right: '0',
		backgroundImage: `url(${CircleBG})`,
		backgroundRepeat: 'no-repeat',
		backgroundPosition: 'center right',
		backgroundSize: '100%',
		transform: 'translateY(-50%)',
	},
});

export const disordersMobileStyle = css({
	[`@media (max-width: ${mobileMinWidthBreakpoint}px)`]: {
		display: 'block',
	},
	[`@media (min-width: ${tabletPortraitMinWidthBreakpoint}px)`]: {
		display: 'none',
	},
	'& p:first-child': {
		...museo900,
		color: orange,
		margin: '0',
		fontSize: '20px',
		lineHeight: '24px',
	},
	'& p:last-child': cx(
		textBlock,
		css({
			color: darkGrey,
			fontSize: '14px',
			margin: 0,
		})
	),
});

export const areYouAtRiskSectionStyle = css({
	position: 'relative',
	padding: '30px 0',
	[`@media (min-width: ${tabletPortraitMinWidthBreakpoint}px)`]: {
		padding: '100px 0',
	},
});

export const atRiskLeftStyle = css({
	maxWidth: '610px',
});

export const atRiskRightStyle = css({
	'& [data-component=Card]': {
		width: '276px',
	},
	[`@media (min-width: ${tabletLandscapeMinWidthBreakpoint}px)`]: {
		position: 'absolute',
		top: '50%',
		transform: 'translateY(-50%)',
		right: '0',
		width: '384px',
		paddingLeft: '57px',
	},

	[`@media (min-width: ${desktopMinWidthBreakpoint}px)`]: {
		width: '529px',
		paddingLeft: '51px',
	},
});

export const resourceSectionStyle = cx(
	contentSection(),
	css({
		[`@media (min-width: ${tabletPortraitMinWidthBreakpoint}px)`]: {
			padding: '100px 0',
		},
	})
);

export const resourceSectionInnerStyle = cx(
	cardSection(0),
	css({
		'& [data-component=ArrowLink]': {
			color: pink,
		},
	})
);

export const updatesSectionStyle = cx(
	contentSection(),
	css({
		backgroundColor: '#fff',
		overflowX: 'hidden',
		[`@media (min-width: ${tabletPortraitMinWidthBreakpoint}px)`]: {
			padding: '150px 0',
		},
	})
);

export const updatesInnerWrapperStyle = cx(
	innerWrapperStyle,
	css({
		overflowX: 'initial',
	})
);

export const updatesSectionInnerStyle = css({
	'& header': {
		marginBottom: '25px',
		position: 'relative',
		'& a': {
			position: 'absolute',
			top: '50%',
			right: '0',
			transform: 'translateY(-50%)',
			color: grey,
			textDecoration: 'none',
			fontSize: '16px',
			'& svg': {
				marginLeft: '4px',
			},
			[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
				fontSize: '12px',
				lineHeight: '24px',
				'& svg': {
					display: 'none',
				},
			},
		},
	},
});

export const ourPartnersSectionStyle = cx(
	contentSection('#fff', '30px'),
	css({
		'& h1': {
			width: 'auto',
			textAlign: 'center',
			marginBottom: '30px',
		},
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			padding: '30px 0',
		},
		[`@media (min-width: ${tabletPortraitMinWidthBreakpoint}px)`]: {
			padding: '100px 0',
			'& h1': {
				marginBottom: '60px',
			},
		},
	})
);

export const ourPartnersLogosWrapperStyle = css({
	display: 'flex',
	justifyContent: 'center',
	'& > a': {
		margin: '0 50px',
		'& img': {
			width: '100%',
		},
		'&:first-child': {
			maxWidth: '255px',
		},
		'&:last-child': {
			maxWidth: '299px',
		},
	},
	[`@media (max-width: ${tabletPortraitMinWidthBreakpoint}px)`]: {
		'& > a': {
			margin: '0 25px',
		},
	},
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		flexFlow: 'column',
		alignItems: 'center',
		'& > a': {
			margin: '25px 0 0 0',
			'&:first-child': {
				marginTop: '0',
			},
			'& img': {
				width: '100%',
			},
		},
	},
});

export const whoAreWeSectionStyle = css({
	background: pink,
	padding: '30px 0',
	[`@media (min-width: ${tabletPortraitMinWidthBreakpoint}px)`]: {
		background: `${pink} url(${WhoWeAre}) no-repeat right 80px center`,
		padding: '100px 0',
	},
});

export const whoAreWeInnerStyle = css({
	maxWidth: '610px',
	[`& .${titleStyle}, & .${bodyTextStyle}, & [data-component=ArrowLink]`]: {
		color: '#fff',
	},
});



// WEBPACK FOOTER //
// ./src/page-styles/index.js